import api from '../../api';
// 获取用户列表
export function getUserList(params) {
  return api.post('/user/getUserList.go', params, false, false).then(res => res);
}
// 新增用户
export function addUser(params) {
  return api.post('/user/addUser.go', params, false, false).then(res => res);
}
// 获取用户
export function getUser(params) {
  return api.post('/user/getUser.go', params, false, false).then(res => res);
}
// 更新用户
export function upUser(params) {
  return api.post('/user/upUser.go', params, false, false).then(res => res);
}
// 删除用户
export function delUser(params) {
  return api.post('/user/delUser.go', params, false, false).then(res => res);
}
// 图片上传
export function fileUpload(params) {
  return api.post('/file/upload', params).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/adminApi/zh/user.js